import get from "lodash/get"
import map from "lodash/map"
import { updateClicksDL } from "utils-lib/analytics/dataLayer"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { getWindow } from "utils-lib/getWindow"
import { isMyWMApp } from "utils-lib/isMyWMApp/index"
import { Link } from "../../../../Base"
import "./LegalLinks.scss"

const LegalLinks = ({ links }) => {
  const ssrWindow = getWindow()

  return (
    <div className="LegalLinks__container" data-testid="LegalLinks">
      <div className="LegalLinks d-flex text-lg-center">
        {map(links, (item, index) => {
          const isExternalLink =
            isMyWMApp ||
            isTeamsitePage(ssrWindow.location.pathname) ||
            get(item, `isExternalLink`, true)

          return (
            <div
              className="LegalLinks__link d-flex align-items-center ml-2 mr-2 m-md-0"
              key={item.legalLinkPath}
            >
              {isExternalLink ? (
                <a
                  data-testid={`LegalLinksButtonTrue-${index}`}
                  className="a-taggable"
                  // eslint-disable-next-line react/no-unknown-property
                  analytics={item.legalLinkText}
                  rel="noopener noreferrer"
                  href={item.legalLinkPath}
                  style={{
                    color: `white`,
                    textDecoration: `none`,
                    display: `inline-flex`,
                  }}
                  onClick={() => {
                    updateClicksDL({
                      ui_element: `LegalLink`,
                      object_content: item.legalLinkText,
                    })
                  }}
                >
                  {item.legalLinkText}
                </a>
              ) : (
                <Link
                  data-testid={`LegalLinksButtonFalse-${index}`}
                  rel="noopener noreferrer"
                  analytics_key={item.legalLinkText}
                  href={item.legalLinkPath}
                  style={{
                    color: `white`,
                    textDecoration: `none`,
                    display: `inline-flex`,
                  }}
                  onClick={() => {
                    updateClicksDL({
                      ui_element: `LegalLink`,
                      object_content: item.legalLinkText,
                    })
                  }}
                >
                  {item.legalLinkText}
                </Link>
              )}
              {index !== links?.length - 1 ? (
                <span className="d-block text-white spacer">|</span>
              ) : null}
            </div>
          )
        })}
      </div>
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// LegalLinks.propTypes = {
//   links: PropTypes.array.isRequired,
// }

export default LegalLinks
